import type { Theme } from '@mui/material'

export const MuiCssBaseline = (theme: Theme) => ({
  styleOverrides: `
    html {
      color-scheme: ${theme.palette.mode};
      scroll-behavior: smooth;
    }
    ::-webkit-horizontal, ::-webkit-scrollbar {
      width: 6px;
      padding: 0;
      background-color: transparent;
    }
    ::-webkit-scrollbar {
      height: 4px;
    }
    ::-webkit-scrollbar-thumb {
      width: 6px;
      background-color: ${theme.palette.line.secondary};
      border-radius: 4px;
      box-shadow: inset 0 0 4px rgb(0 0 0 / 5%);
    }
    ::-webkit-scrollbar-track {
      background-color: ${theme.palette.background.paper};
    }

    input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0px 1000px white inset;
    }
  `,
})
